var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimer = function SvgTimer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#101340",
    d: "M1.934 18.39a.7.7 0 0 0 1.164-.78l-1.164.78Zm3.574 1.59a.7.7 0 0 0-.758 1.177l.758-1.176ZM18.301 13a8.3 8.3 0 0 1-8.3 8.3v1.4c5.357 0 9.7-4.343 9.7-9.7h-1.4ZM1.7 13A8.3 8.3 0 0 1 10 4.7V3.3C4.643 3.3.3 7.643.3 13h1.4ZM10 4.7a8.3 8.3 0 0 1 8.3 8.3h1.4c0-5.357-4.343-9.7-9.7-9.7v1.4ZM3.098 17.61A8.258 8.258 0 0 1 1.7 13H.3c0 1.993.602 3.848 1.634 5.39l1.164-.78ZM10 21.3a8.258 8.258 0 0 1-4.493-1.32l-.758 1.177A9.658 9.658 0 0 0 10 22.7v-1.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#101340",
    strokeLinecap: "round",
    strokeWidth: 1.4,
    d: "M8 1h4M10 1v3M10 13l3-3M16.5 6l.5-.5"
  })));
};
export default SvgTimer;